module.exports = __webpack_public_path__ + "img/love.250dc3db.gif";